import { fmtBRL, fmtNum } from "@/lib/medicoes";

export default function ItensResumoTable({ itens = [], anteriores = [] }) {
  const prevByItem = {};
  anteriores.forEach((m) => (m.itens || []).forEach((i) => {
    prevByItem[i.numero_item] = prevByItem[i.numero_item] || [];
    prevByItem[i.numero_item].push({ numero: m.numero, q: i.quantidade_periodo, status: m.status });
  }));
  const total = itens.reduce((s, i) => s + (i.valor_periodo || 0), 0);
  return (
    <div className="overflow-x-auto" data-testid="itens-resumo-table">
      <table className="w-full text-xs">
        <thead className="bg-[#1E293B] text-left">
          <tr>
            {["Item", "Descrição", "Un", "Contratado", "Anterior", "Período", "Acumulado", "Saldo", "PU", "Valor período", "Valor acum.", "%", "Medições anteriores"].map((h) => (
              <th key={h} className="px-3 py-2.5 uppercase-label !text-[10px] whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {itens.map((i) => (
            <tr key={i.numero_item} className="border-t border-[#334155]" data-testid={`resumo-item-${i.numero_item}`}>
              <td className="px-3 py-2 font-mono">{i.numero_item}</td>
              <td className="px-3 py-2 min-w-[200px]">{i.descricao}{i.observacao && <div className="text-[10px] text-[#94A3B8] mt-0.5">Obs.: {i.observacao}</div>}</td>
              <td className="px-3 py-2">{i.unidade_medida}</td>
              <td className="px-3 py-2 font-mono text-right">{fmtNum(i.quantidade_contratada, 4)}</td>
              <td className="px-3 py-2 font-mono text-right">{fmtNum(i.quantidade_anterior, 4)}</td>
              <td className="px-3 py-2 font-mono text-right text-[#FFDF00]">{fmtNum(i.quantidade_periodo, 4)}</td>
              <td className="px-3 py-2 font-mono text-right">{fmtNum(i.quantidade_acumulada, 4)}</td>
              <td className={`px-3 py-2 font-mono text-right ${i.saldo_quantidade < 0 ? "text-[#EF4444]" : ""}`}>{fmtNum(i.saldo_quantidade, 4)}</td>
              <td className="px-3 py-2 font-mono text-right">{fmtBRL(i.valor_unitario)}</td>
              <td className="px-3 py-2 font-mono text-right text-[#FFDF00]">{fmtBRL(i.valor_periodo)}</td>
              <td className="px-3 py-2 font-mono text-right">{fmtBRL(i.valor_acumulado)}</td>
              <td className="px-3 py-2 font-mono text-right">{fmtNum(i.pct_execucao, 2)}%</td>
              <td className="px-3 py-2 text-[10px] text-[#94A3B8] whitespace-nowrap">
                {(prevByItem[i.numero_item] || []).map((p) => `nº ${p.numero}: ${fmtNum(p.q, 4)}`).join(" · ") || "—"}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t border-[#334155] bg-[#1E293B]/60">
            <td colSpan={9} className="px-3 py-2.5 text-right uppercase-label">Total da medição</td>
            <td data-testid="resumo-total" className="px-3 py-2.5 font-mono text-right text-[#FFDF00]">{fmtBRL(total)}</td>
            <td colSpan={3} />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
